module.exports = __webpack_public_path__ + "img/owl-purple-left.f800e557.png";